<template>
  <div class="job-details">
    <LoadingOverlay v-if="!isFetchingJobDetails" />
    <div v-else-if="isJobFound">
      <div class="pb-3">
        <CRow class="m-0">
          <CCol md="12" sm="12" lg="6" class="d-block d-lg-none pb-3 pt-3">
            <div v-if="currentUserRole === 'customer_user'" class="float-right">
              <CButton
                class="mr-2 nowrap"
                color="primary"
                shape="pill"
                @click="backtocardview"
                >Back to Activity</CButton
              >
            </div>
            <div v-else class="float-right">
              <CButton
                class="mr-2 nowrap"
                color="primary"
                shape="pill"
                @click="backtocardview"
                >Back</CButton
              >
              <CButton
                id="backbtn"
                class="mr-2 nowrap"
                sm="4"
                :disabled="!getPreviousJobId"
                color="primary"
                shape="pill"
                @click="navigateto(getPreviousJobId)"
              >
                <CIcon name="cil-caret-left" />
              </CButton>
              <CButton
                id="nextbtn"
                class="mr-2 nowrap"
                sm="4"
                :disabled="!getNextJobId"
                color="primary"
                shape="pill"
                @click="navigateto(getNextJobId)"
              >
                <CIcon name="cil-caret-right" />
              </CButton>
            </div>
          </CCol>
          <CCol md="12" sm="12" lg="6">
            <h3 class="text-primary main-title">Job Detailed View</h3>
          </CCol>
          <CCol md="12" sm="12" lg="6" class="d-none d-lg-block">
            <div v-if="currentUserRole === 'customer_user'" class="float-right">
              <CButton
                class="mr-2 nowrap"
                color="primary"
                shape="pill"
                @click="backtocardview"
                >Back to Activity</CButton
              >
            </div>
            <div v-else class="float-right">
              <CButton
                class="mr-2 nowrap"
                color="primary"
                shape="pill"
                @click="backtocardview"
                >Back</CButton
              >
              <CButton
                id="prevbtn"
                class="mr-2 nowrap"
                sm="4"
                :disabled="!getPreviousJobId"
                color="primary"
                shape="pill"
                @click="navigateto(getPreviousJobId)"
              >
                <CIcon name="cil-caret-left" />
              </CButton>
              <CButton
                id="nextbtn"
                class="mr-2 nowrap"
                sm="4"
                :disabled="!getNextJobId"
                color="primary"
                shape="pill"
                @click="navigateto(getNextJobId)"
              >
                <CIcon name="cil-caret-right" />
              </CButton>
            </div>
          </CCol>
        </CRow>
      </div>
      <CRow class="m-0 pb-4 mb-3">
        <CCol lg="8" class="f-12">
          <CCard>
            <CCardBody>
              <CRow class="pb-3">
                <CCol lg="4" class="pb-2 px-0 dark-block">
                  <div>
                    <JobInfo :jobDetail="profile" :isEditable="isEditable" />
                  </div>
                  <div>
                    <JobContactInfo
                      :profile="profile"
                      :isCandidate="false"
                      :isEditable="isEditable"
                    />
                  </div>
                </CCol>
                <CCol lg="8">
                  <CRow
                    lg="12"
                    class="justify-content-end text-primary mb-2"
                    v-if="isJobCreatedByParent"
                  >
                    Created By:&nbsp;<strong>{{ isJobCreatedByParent }}</strong>
                  </CRow>
                  <CRow class="mb-2">
                    <CCol lg="12">
                      <ConsultantDetails
                        :profile="profile"
                        :isEditable="isEditable"
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol lg="12">
                      <Preferences
                        :profile="profile"
                        :isEditable="isEditable"
                      />
                    </CCol>
                    <CCol lg="12">
                      <AdditionalInfo
                        :profile="profile"
                        :isEditable="isEditable"
                      />
                    </CCol>
                  </CRow>
                  <CRow v-if="!isCandidateSupplierFromAccessToken">
                    <CCol lg="12">
                      <Details :profile="profile" :isEditable="isEditable" />
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
          <CCard>
            <CCardBody>
              <GenericTabFilters
                :isShowRefresh="genericTabFilter.isShowRefresh"
                :refreshCallBack="refreshCallBack"
                :filterCallBack="filterCallBack"
                :activeTab="information_step"
                :tabSelectCallBack="tabSelectCallBack"
                :tabs="tabs"
                :isShowFavourite="true"
                page="JobDetails"
                ref="GenericTabFilters"
                :isShowMatchFilter="true"
                :inProcessSubCount="inProcessSubCount"
              />
              <div class="info-content mt-2">
                <div v-if="information_step === 0 && !getTabInfo['tab_id']">
                  <JobRequirementDetails
                    :profile="profile"
                    ref="JobRequirementDetails"
                    :isEditable="isEditable"
                  />
                </div>
                <div v-if="information_step && getTabInfo['tab_id']">
                  <Candidates
                    :candidatesInfo="candidates"
                    :selectedCandidate="candidateDetails"
                    @candidateSelect="handleCandidateSelect"
                    :selectedTabIndex="information_step"
                    @actionModalEvent="actionModalEvent"
                    :actionModal="actionModal"
                    @previewCV="preview"
                  />
                  <div
                    v-if="noMoreCandidates && candidates.length"
                    class="text-center mt-2"
                  >
                    <CBadge color="primary" class="font-weight-normal"
                      ><span>No More Candidates Found</span></CBadge
                    >
                  </div>
                </div>
                <div v-if="information_step === 5 && !getTabInfo['tab_id']">
                  <history-info
                    ref="historyInfo"
                    :jobDetails="getJobDetailsById"
                  />
                </div>
                <div v-if="information_step === 6 && !getTabInfo['tab_id']">
                  <CandidateOffer ref="candidateOffer" />
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
        <!-- Right Side section start here -->
        <CCol lg="4" id="candidateDetails" class="paddingself">
          <CCard
            class="child2-layout p-3 f-12"
            style="padding-top: 10px !important"
            v-if="isCandidateDetailsNotEmpty"
          >
            <CRow v-if="candidateStatus" class="bottom-line">
              <CCol
                col="8"
                class="text-primary font-weight-bold"
                style="margin-top: -4px"
              >
                <CRow class="pb-1">
                  <CCol col="12">
                    <div class="d-flex">
                      <span class="mr-2">Status:</span>
                      <span>
                        <span>{{ candidateStatus }} </span>
                        <span class="text-nowrap" v-if="candidateSubStatus">{{
                          `(${candidateSubStatus})`
                        }}</span>
                      </span>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
              <CCol col="4" style="margin-top: -9px; margin-bottom: 11px">
                <div
                  class="d-flex justify-content-end"
                  v-if="index_selectedCandidate > -1"
                >
                  <CButton
                    class="pt-0 pb-0"
                    @click="handleCandidateSelect(previousCandidate)"
                    :disabled="!previousCandidate"
                  >
                    <CIcon name="cil-caret-left" class="text-primary" />
                  </CButton>
                  <CButton
                    class="pt-0 pb-0"
                    @click="handleCandidateSelect(nextCandidate)"
                    :disabled="!nextCandidate"
                  >
                    <CIcon name="cil-caret-right" class="text-primary" />
                  </CButton>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="4" class="px-0 mb-1">
                <div>
                  <div class="d-flex">
                    <img
                      :src="candidateProfilePicture"
                      alt="DP"
                      class="rounded-circle display-img candidateimg m-auto"
                    />
                  </div>
                  <span
                    class="fs-13 pt-2 d-block text-center"
                    style="color: #1571cc; font-weight: 500"
                    >{{ name }}</span
                  >
                  <!-- <span class="d-block text-center"
                    >Candidate ID: {{ candidateId  }}</span
                  > -->
                  <span class="d-block text-center"
                    >Candidate ID: {{ displayCandidateId }}</span
                  >
                </div>
              </CCol>
              <CCol lg="8" class="mb-1">
                <CRow>
                  <CCol lg="12" class="px-0 mb-1">
                    <h5 class="text-primary text-left">
                      {{ candidateType }}
                    </h5>
                  </CCol>
                  <CCol lg="12" class="mb-1 px-0 pl-5">
                    <CRow class="mx-0 mb-1">
                      <CCol col="12" class="px-0 d-flex">
                        <div
                          class="d-flex action-set"
                          style="margin-left: unset"
                        >
                          <CDropdown
                            placement="left"
                            class="text-nowrap mx-1 drop-padding"
                            :class="{
                              'text-primary': candidateActions.length,
                              'text-primary-disabled': !candidateActions.length,
                            }"
                            :disabled="!candidateActions.length ? true : false"
                            v-if="
                              [
                                Role.customerAdmin,
                                Role.customerRecruiter,
                              ].includes(currentUserRole) &&
                              candidateActions &&
                              candidateActions.length
                            "
                          >
                            <template #toggler>
                              <div
                                class="font-weight-bold"
                                :class="{
                                  'cursor-default': !candidateActions.length,
                                }"
                              >
                                <i
                                  class="fas fa-ellipsis-v"
                                  :class="{
                                    'circle-border': candidateActions.length,
                                    'circle-border-disabled':
                                      !candidateActions.length,
                                  }"
                                ></i>
                                Action
                              </div>
                            </template>
                            <a
                              class="dropdown-item cursor-action"
                              v-for="data in candidateActions"
                              :key="data.action_id"
                              @click="candidateActionEvent(data)"
                              :class="{
                                'positive-action': checkPositiveAction(data),
                              }"
                            >
                              {{ data.label }}
                            </a>
                          </CDropdown>
                          <CButton
                            size="sm"
                            color="primary"
                            class="action-1"
                            @click="navigateToCandidateDetail"
                          >
                            View
                          </CButton>
                        </div>
                      </CCol>
                    </CRow>
                    <CRow
                      class="mx-0"
                      v-if="
                        [Role.customerAdmin, Role.customerRecruiter].includes(
                          currentUserRole
                        )
                      "
                    >
                      <CCol col="12" class="px-0 mb-1 d-flex">
                        <div
                          class="d-flex action-set"
                          style="margin-left: unset"
                        >
                          <CDropdown
                            v-if="
                              !isJobSupplier &&
                              !isCandidateSupplierFromAccessToken
                            "
                            placement="left"
                            class="text-nowrap text-primary mx-1 drop-padding"
                            :class="{
                              'text-primary': !isJobSupplier,
                              'text-primary-disabled': isJobSupplier,
                            }"
                            :disabled="isJobSupplier ? true : false"
                          >
                            <template
                              #toggler
                              :class="{ 'cursor-default': isJobSupplier }"
                            >
                              <div class="action-1 font-weight-bold">
                                <i
                                  class="fas fa-ellipsis-v circle-border"
                                  :class="{
                                    'circle-border': !isJobSupplier,
                                    'circle-border-disabled': isJobSupplier,
                                  }"
                                ></i>
                                Contact
                              </div>
                            </template>
                            <a
                              class="dropdown-item cursor-action"
                              v-for="data in getContactMethods"
                              :key="data.code"
                              @click="openContactModal(data.code)"
                            >
                              {{ data.label }}
                            </a>
                          </CDropdown>
                          <CButton
                            v-if="!isCandidateSupplierFromAccessToken"
                            size="sm"
                            color="primary"
                            variant="outline"
                            class="action-2"
                            @click="openCommentModal"
                          >
                            Comment
                          </CButton>
                        </div>
                      </CCol>
                    </CRow>
                    <div class="mt-2 cv-icon d-flex align-items-center">
                      <span
                        v-c-tooltip="{
                          content: 'View CV/Resume',
                          appendToBody: true,
                        }"
                      >
                        <CButton
                          colour="primary"
                          class="btn-link p-0 mx-1"
                          :disabled="!candidateInfo.cv_document"
                          @click="previewCV(candidateInfo)"
                        >
                          <i class="fa-solid fa-eye m-0"></i>
                        </CButton>
                      </span>
                      <span
                        v-c-tooltip="{
                          content: 'Download CV/Resume',
                          appendToBody: true,
                        }"
                      >
                        <CButton
                          colour="primary"
                          class="btn-link p-0 mx-2"
                          :disabled="!candidateInfo.cv_document"
                          :href="generateLocalFileUrl(candidateInfo.cv_document)"
                          download
                          target="_self"
                        >
                          <i class="fa-solid fa-download m-0"></i>
                        </CButton>
                      </span>
                      <span
                        class="text-primary"
                        v-if="
                          candidateDetails.reference_type &&
                          [4, 3].includes(
                            candidateDetails.reference_type.reference_type_id
                          )
                        "
                      >
                        <i
                          class="fa-solid fa-circle-info"
                          v-c-tooltip="{
                            content: `${candidateDetails.reference_type.type_name} Match`,
                            appendToBody: true,
                          }"
                        ></i>
                      </span>
                      <div
                        class="d-flex ml-4"
                        v-if="checkFastTrack(candidateActions)"
                      >
                        <CButton
                          size="sm"
                          color="primary"
                          class="action-1"
                          @click="openFastTrackModal"
                        >
                          Fast Track
                        </CButton>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <div class="candidate-detail scroll-arrow">
              <a
                id="left2"
                class="arrow left clickable fa-disabled"
                @click="arrowClick(2, 'left')"
              >
                <i class="fa fa-chevron-circle-left" aria-hidden="true" />
              </a>
              <a
                id="right2"
                class="arrow right clickable"
                @click="arrowClick(2, 'right')"
              >
                <i class="fa fa-chevron-circle-right" aria-hidden="true" />
              </a>
              <div class="scroll-wrapper">
                <ul
                  v-if="isCandidateSupplierFromAccessToken"
                  class="nav nav-tabs"
                  id="agencyotherinfoNav"
                >
                  <li
                    role="presentation"
                    v-for="(data, index) in agencyCandidateDetailsTab"
                    :key="index"
                    v-bind:class="{ active: step2 === index }"
                  >
                    <a
                      class="clickable btn btnpadding"
                      @click="fetchShortListInProgressJobs(index)"
                      >{{ data }}</a
                    >
                  </li>
                </ul>
                <ul v-else class="nav nav-tabs" id="otherinfoNav">
                  <li
                    role="presentation"
                    v-for="(data, index) in candidateDetailsTab"
                    :key="index"
                    v-bind:class="{ active: step2 === index }"
                  >
                    <a
                      class="clickable btn btnpadding"
                      @click="fetchShortListInProgressJobs(index)"
                      >{{ data }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="info-content mt-2">
              <div v-if="step2 === 0">
                <PersonalInfo
                  class="pl-3 personal-info"
                  :candidate="candidateInfo"
                />
              </div>
              <div v-if="step2 === 1">
                <Documents :candidate="candidateInfo" />
              </div>
              <div v-if="step2 === 2">
                <CandidateJobs :jobs="getShortListInProgressJobs" />
              </div>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </div>
    <h4 v-else class="text-muted text-center pt-4 mt-4">No Job Found</h4>
    <ActionModal
      v-if="actionModal.isShowPopup"
      :isShowPopup="actionModal.isShowPopup"
      :details="actionModal.candidateDetails"
      :action="actionModal.action"
      @modalCallBack="actionModalCallBack"
      @openFrontSheet="openFrontSheet"
      :candidate="actionModal.candidate"
      :job="actionModal.job"
    />
    <FastTrackModal
      v-if="fastTrackModal.isShowPopup"
      :isShowPopup="fastTrackModal.isShowPopup"
      :details="fastTrackModal.details"
      :action="fastTrackModal.action"
      @modalCallBack="fastTrackModalCallBack"
      :candidateDetail="fastTrackModal.candidate"
      :jobDetail="fastTrackModal.job"
    />
    <CommentModal
      v-if="commentModal.isShowPopup"
      :isShowPopup="commentModal.isShowPopup"
      :candidate_id="commentModal.candidate_id"
      :isBtnHide="this.isBtnHide"
      @commentModalCallBack="commentModalCallBack"
    />
    <CToaster
      v-if="getUpdateToast.isShow"
      :autohide="getUpdateToast.autohide"
      position="bottom-center"
    >
      <CToast :class="getUpdateToast.cssClass" :show="true">{{
        getUpdateToast.msg || ""
      }}</CToast>
    </CToaster>
    <EmailModal
      v-if="contactModal.email"
      :isShowPopup="contactModal.email"
      :email_id="candidateDetails['candidate'].email"
      :job_id="candidateDetails.job_id"
      :candidate_uid="candidateDetails.candidate_uid"
      :alternate_email="candidateDetails['candidate'].alternate_email"
      @emailModalCallBack="modalCallBack"
      @conversationModalCallBack="conversationModalCallBack"
      @openCommentModal="openCommentModal"
    />
    <SMSModal
      v-if="contactModal.sms"
      :isShowPopup="contactModal.sms"
      :phone="candidateDetails['candidate'].phone"
      :modal="methods"
      @messageModalCallBack="modalCallBack"
      @openCommentModal="openCommentModal"
    />
    <WhatsAppModal
      v-if="contactModal.whatsapp"
      :isShowPopup="contactModal.whatsapp"
      :phone="candidateDetails['candidate'].whatsapp"
      :modal="methods"
      @messageModalCallBack="modalCallBack"
      @openCommentModal="openCommentModal"
    />
    <FrontSheetModal
      v-if="frontSheetModal.isShowPopup"
      :isShowPopup="frontSheetModal.isShowPopup"
      @modalCallBack="frontSheetModalCallBack"
      :candidateDetail="frontSheetModal.candidate"
      :jobDetail="frontSheetModal.job"
      :frontSheets="frontSheetModal.comments"
      :frontSheetInfo="frontSheetModal.frontSheetInfo"
    />
    <Modal
      v-if="confirmationModal.isShowPopup"
      :modalTitle="confirmationModal.modalTitle"
      :modalColor="confirmationModal.modalColor"
      :modalContent="confirmationModal.modalContent"
      :isShowPopup="confirmationModal.isShowPopup"
      :buttons="confirmationModal.buttons"
      :modalCallBack="confirmationModalCallBack"
      :closeOnBackdrop="confirmationModal.closeOnBackdrop"
    />
    <SubmissionModal
      :modalTitle="submissionModal.modalTitle"
      :modalColor="submissionModal.modalColor"
      :modalContent="submissionModal.modalContent"
      :isShowPopup="submissionModal.isShowPopup"
      :buttons="submissionModal.buttons"
      :modalCallBack="submissionModalCallBack"
      :closeOnBackdrop="submissionModal.closeOnBackdrop"
      v-if="submissionModal.isShowPopup"
    />
    <DeleteModal
      v-if="deleteModal.isShowPopup"
      :isShowPopup="deleteModal.isShowPopup"
      :delete_id="deleteModal.delete_id"
      :email_subject="deleteModal.subject"
      @deleteModalCallBack="deleteModalCallBack"
      @emailModalCallBack="modalCallBack"
    />
    <VoiceCallModal
      v-if="contactModal.phone"
      :isShowPopup="contactModal.phone"
      :phone="candidateDetails['candidate'].phone"
      @phoneModalCallBack="modalCallBack"
    />
    <Modal
      v-if="interViewModal.isShowPopup"
      :modalTitle="interViewModal.modalTitle"
      :modalColor="interViewModal.modalColor"
      :modalContent="interViewModal.modalContent"
      :isShowPopup="interViewModal.isShowPopup"
      :buttons="interViewModal.buttons"
      :modalCallBack="interViewModalCallBack"
      :closeOnBackdrop="false"
    />
    <CandidateOfferDocsModal
      v-if="!isCandidateSupplierFromAccessToken"
      :offerModel="offerModel"
    />
    <CandidateOnboardDocsModal
      v-if="!isCandidateSupplierFromAccessToken"
      :onboardModel="onboardModel"
    />

    <OfferOnBoardModal
      v-if="offerOnBoardModal.isShowPopup"
      :isShowPopup="offerOnBoardModal.isShowPopup"
      :title="offerOnBoardModal.title"
      :infoData="offerOnBoardModal.details"
      :action="offerOnBoardModal.action"
      :isOnBoard="offerOnBoardModal.isOnBoard"
      :isOffer="offerOnBoardModal.isOffer"
      @actionCallBack="offerOnBoardModalCallBack"
    />
    <PreviewModal
      v-if="previewModal.isShowPopup"
      :modalTitle="previewModal.modalTitle"
      :modalColor="previewModal.modalColor"
      :isShowPopup="previewModal.isShowPopup"
      :buttons="previewModal.buttons"
      :modalCallBack="previewModalCallBack"
      :isPreview="previewModal.isPreview"
      :iframe="iframe"
      :size="previewModal.size"
      :closeOnBackdrop="previewModal.closeOnBackdrop"
    />
    <OnErrorModal
      v-if="errorModal.isShowPopup"
      :isShowPopup="errorModal.isShowPopup"
      @modalCallBack="errorModalCallBack"
      :candidate="errorModal.candidate"
      :job="errorModal.job"
      :action="errorModal.action"
    />
    <Modal
      v-if="notificationModal.isShowPopup"
      :modalTitle="notificationModal.modalTitle"
      :modalColor="notificationModal.modalColor"
      :modalContent="notificationModal.modalContent"
      :isShowPopup="notificationModal.isShowPopup"
      :buttons="notificationModal.buttons"
      :modalCallBack="notificationModalCallBack"
      :closeOnBackdrop="false"
    />
    <CheckListModal
      v-if="checkListModal.isShowPopup"
      :isShowPopup="checkListModal.isShowPopup"
      @modalCallBack="checkListModalCallBack"
      :candidateDetails="checkListModal.candidateDetails"
      :jobDetails="checkListModal.jobDetails"
      :actionInfo="checkListModal.actionInfo"
      :isActionCompleted="checkListModal.isActionCompleted"
      :activeTab="checkListModal.activeTab"
      :accordion="checkListModal.accordion"
      @uploadDocActionCallBack="uploadDocActionCallBack"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  isObject,
  isEmptyObjectCheck,
  getScope,
  Role,
  deepClone,
  getPositiveActionIds,
  appendAccessToken,
  generateFullUrlWithToken,
  generateLocalFileUrl,
  candidateDetailPath,
} from "@/helpers/helper";
import moment from "moment";
import _ from "lodash";

import ContactInfo from "@/containers/CandidateDetailsTalentFind/ContactInfo";
import JobContactInfo from "@/containers/JobsDetailedView/ContactInformation";
import JobDetails from "@/containers/CandidateDetailsTalentFind/JobDetails";
import Details from "@/containers/JobsDetailedView/Details";
import ConsultantDetails from "@/containers/JobsDetailedView/ConsultantDetails";
import Applications from "@/containers/JobsDetailedView/Application/Applications";
import PersonalInfo from "@/containers/JobsDetailedView/Information/PersonalInfo";
import Candidates from "@/containers/JobsDetailedView/Candidate/CandidateMatch";
import Preferences from "@/containers/JobsDetailedView/Preferences";
import AdditionalInfo from "@/containers/JobsDetailedView/AdditionalInfo";
import JobRequirementDetails from "@/containers/JobsDetailedView/Application/JobRequirementDetails";
import Comments from "@/containers/JobsDetailedView/Application/Comments";
import Vault from "@/containers/JobsDetailedView/Application/Vault";
import JobMatch from "@/containers/JobsDetailedView/Candidate/JobMatch";
import JobInProcess from "@/containers/JobsDetailedView/Candidate/JobInProcess";
import Documents from "@/containers/JobsDetailedView/Candidate/Documents";
import Select from "@/components/reusable/Fields/Select";
import GenericTabFilters from "@/components/reusable/GenericTabFilters/index";
import ActionModal from "@/components/reusable/GenericTabFilters/ActionModal";
import OfferOnBoardModal from "@/components/reusable/OfferOnBoardModal";
import CommentModal from "@/containers/JobsDetailedView/Candidate/CommentModal";
import HistoryInfo from "@/containers/JobsDetailedView/History/HistoryInfo.vue";
import EmailModal from "@/containers/Communication/EmailModal";
import SMSModal from "@/containers/Communication/MessageModal";
import WhatsAppModal from "@/containers/Communication/MessageModal";
import CandidateJobs from "@/containers/JobsDetailedView/Candidate/CandidateJobs";
import SubmissionModal from "@/components/reusable/Modal";
import DeleteModal from "@/containers/Communication/DeleteModal";
import VoiceCallModal from "@/containers/Communication/VoiceCallModal";
import Modal from "@/components/reusable/Modal";
import isJobSupplier from "@/mixins/isJobSupplier";
import JobInfo from "@/containers/JobsDetailedView/JobInfo";
import FastTrackModal from "@/components/reusable/GenericTabFilters/FastTrackModal";
import FrontSheetModal from "@/containers/Frontsheet/FrontSheetModal";
import OnErrorModal from "@/components/reusable/GenericTabFilters/OnErrorModal";

import CandidateOffer from "@/containers/JobsDetailedView/Candidate/CandidateOffer";

import Vue from "vue";

import PreviewModal from "@/components/reusable/PreviewModal";
import pdf from "vue-pdf";

import UploadDocument from "@/containers/CandidateProfile/UploadDocument";
import CropperModal from "@/components/reusable/CropperModal";
import CandidateOfferDocsModal from "@/containers/JobsDetailedView/CandidateOfferDocsModal";
import CandidateOnboardDocsModal from "@/containers/JobsDetailedView/CandidateOnBoardDocsModal";
import {
  getLocalOrgDetail,
  getFilterQueryStringWithoutArray,
} from "@/helpers/helper";
import urlParse from "url";
import CheckListModal from "@/components/reusable/CheckList/CheckListModal";
import { BASE_URL } from "@/service_urls";

export default {
  name: "CandidateDetails",
  mixins: [isJobSupplier],
  components: {
    PreviewModal,
    UploadDocument,
    CropperModal,
    ContactInfo,
    JobDetails,
    Details,
    ConsultantDetails,
    Applications,
    PersonalInfo,
    Candidates,
    AdditionalInfo,
    Preferences,
    JobContactInfo,
    JobRequirementDetails,
    Comments,
    Vault,
    JobMatch,
    JobInProcess,
    Documents,
    Select,
    GenericTabFilters,
    ActionModal,
    CommentModal,
    HistoryInfo,
    EmailModal,
    WhatsAppModal,
    SMSModal,
    CandidateJobs,
    SubmissionModal,
    DeleteModal,
    Modal,
    CandidateOffer,
    CandidateOfferDocsModal,
    CandidateOnboardDocsModal,
    VoiceCallModal,
    OfferOnBoardModal,
    JobInfo,
    FastTrackModal,
    FrontSheetModal,
    OnErrorModal,
    CheckListModal,
  },
  data() {
    return {
      showbtn: true,
      currentUserRole: getScope(),
      Role,
      information_step: 1,
      candidateDetailsTab: ["Information", "Documents", "Jobs"],
      agencyCandidateDetailsTab: ["Information"],
      step1: 0,
      step2: 0,
      candidateDetails: null,
      MatchedjobDetails: null,
      secondaryFilters: {},
      genericTabFilter: { isShowRefresh: false },
      actionModal: {
        isShowPopup: false,
        candidate_uid: null,
        candidateDetails: null,
        action: null,
        candidate: null,
        job: null,
      },
      fastTrackModal: {
        isShowPopup: false,
        job_id: null,
        details: null,
        action: null,
        candidate: null,
        job: null,
      },
      frontSheetModal: {
        isShowPopup: false,
        candidate: null,
        job: null,
        comments: [],
        frontSheetInfo: null,
      },
      commentModal: {
        isShowPopup: false,
        candidate_uid: null,
      },
      errorModal: {
        isShowPopup: false,
        candidate: null,
        job: null,
        action: null,
      },
      contactModal: {
        email: false,
        phone: false,
        whatsapp: false,
        sms: false,
        comment: false,
      },
      modal: null,
      submissionModal: {
        modalTitle: "NOTIFICATION",
        modalColor: "primary",
        modalContent: "Is the profile ready for submission?",
        isShowPopup: false,
        buttons: ["No", "Yes"],
        closeOnBackdrop: false,
      },
      confirmationModal: {
        modalTitle: "NOTIFICATION",
        modalColor: "primary",
        modalContent: "Frontsheet Not Available for this Job & Candidate",
        isShowPopup: false,
        buttons: [
          { class: "secondary", button: "Close" },
          { class: "primary", button: "Create" },
        ],
        closeOnBackdrop: false,
      },
      deleteModal: {
        isShowPopup: false,
        delete_id: null,
        subject: null,
      },
      messageId: null,
      isBtnHide: true,
      methods: null,
      interViewModal: {
        modalColor: "primary",
        modalTitle: "Interview Confirmation",
        modalContent: "Is the profile ready for interview?",
        buttons: ["No", "Yes"],
        isShowPopup: false,
      },
      offerModel: {
        isShowPopup: false,
        data: null,
      },
      onboardModel: {
        isShowPopup: false,
        data: null,
      },
      offerOnBoardModal: {
        isShowPopup: false,
        job_id: null,
        details: null,
        action: null,
        title: null,
        isOffer: false,
        isOnBoard: false,
      },
      previewModal: {
        modalColor: "primary",
        modalTitle: "Document Preview",
        isShowPopup: false,
        buttons: ["OK"],
        isPreview: false,
        size: "lg",
        closeOnBackdrop: false,
      },
      iframe: {
        src: "",
        loaded: false,
        isImg: false,
        pdf: {
          ispdf: false,
          src: "",
          numPages: undefined,
          addContentClasses: "",
        },
      },
      notificationModal: {
        modalColor: "danger",
        modalTitle: "Notification",
        modalContent:
          "This account is entitled only up to Offer; please contact your Administrator for further access!",
        buttons: ["OK"],
        isShowPopup: false,
      },
      inProcessSubCount: {
        submitted: null,
        interview: null,
        offered: null,
        onboard: null,
      },
      checkListModal: {
        isShowPopup: false,
        candidateDetails: null,
        jobDetails: null,
        actionInfo: null,
        isActionCompleted: false,
      },
      generateFullUrlWithToken,
      generateLocalFileUrl,
    };
  },
  computed: {
    ...mapGetters([
      "isFetchingJobDetails",
      "jobListBackUrl",
      "getPreviousJobId",
      "getNextJobId",
      "getJobs",
      "getJobDetailsById",
      "getCandidateListForJobID",
      "noMoreCandidates",
      "getSubStatusOptions",
      "getJobCandidateTabs",
      "getJobFilterOptions",
      "getJobSubFilterOptions",
      "getJobGenderFilterOptions",
      "getTabInfo",
      "getDisplayStatusSubStatus",
      "getTabFilterCandidateCount",
      "getCandidateDetailsForID",
      "getUpdateToast",
      "getContactMethods",
      "getShortListInProgressJobs",
      "getCustomerId",
      "getJobDocuments",
      "documentType",
      "uploaded",
      "getUploadedDocument",
      "candidateProfile",
      "getOfferDetailsforCandidate",
      "getJobCandidatePagination",
      "isCandidateSupplierFromAccessToken",
      "customerDocumentLibrary",
      "documentExtensions",
      "getJobPaginationPageNumber",
      "currentUserType",
      "jobCandidateFrontSheet",
      "getOrgIDFromAccessToken",
      "getPathAcronymFromAccessToken"
    ]),
    options() {
      return {
        filterMatches: [
          { code: null, label: "All" },
          { code: true, label: "Applied" },
          { code: false, label: "Talent Pool" },
        ],
        filterShortlists: this.getSubStatusOptions || [],
        mainFilter: this.getJobFilterOptions || [],
        subFilter: this.getJobSubFilterOptions || [],
        document_type:
          this.documentType
            .filter(({ code }) => [23, 24].includes(code))
            .map((data) => data) || [],
        // 23 - Offer Letter, 24 - Employment Contract
      };
    },
    isEditable() {
      return (
        ([Role.customerAdmin, Role.customerRecruiter].includes(
          this.currentUserType?.code || this.currentUserRole
        ) &&
          !this.isCandidateSupplierFromAccessToken &&
          !this.isJobSupplier) ||
        false
      );
    },
    Matchedjobs() {
      if (this.getJobs && this.getJobs.length) {
        if (this.MatchedjobDetails === null)
          this.MatchedjobDetails = this.getJobs[0];
        return this.getJobs;
      }
      return [];
    },
    candidates() {
      if (
        this.getCandidateListForJobID &&
        this.getCandidateListForJobID.length
      ) {
        let { query } = this.$route;
        if (this.candidateDetails === null) {
          let filteredCandidate = [];
          if (query?.candidate_uid) {
            const candidate_uid = parseInt(query?.candidate_uid);
            filteredCandidate = this.getCandidateListForJobID.filter(
              (candidate) => candidate?.candidate_uid === candidate_uid
            );
          }
          if (filteredCandidate.length) {
            this.candidateDetails = filteredCandidate[0];
          } else {
            this.candidateDetails = this.getCandidateListForJobID[0];
          }
        }
        return this.getCandidateListForJobID;
      }
      this.candidateDetails = null;
      return [];
    },
    isCandidateRole() {
      return (
        this.currentUserRole === Role.customerCandidate ||
        this.currentUserRole === Role.systemCandidate
      );
    },
    isCustomerUserRole() {
      return this.currentUserRole === Role.customerUser;
    },
    referenceId() {
      return `${this.getJobDetailsById?.job_id}` || "--";
      // return `${this.getJobDetailsById?.display_uid ? this.getJobDetailsById?.display_uid : this.getJobDetailsById?.job_id}` || "--";
    },
    jobID() {
      return `${this.getJobDetailsById?.job_id}` || "--";
    },
    candidateInfo() {
      return this.candidateDetails?.candidate;
    },
    name() {
      return this.candidateInfo?.full_name || null;
    },
    candidateId() {
      return this.candidateInfo?.candidate_uid || null;
    },
    displayCandidateId() {
      return this.candidateInfo?.display_uid || null;
    },
    candidateType() {
      return this.candidateInfo?.candidate_type?.candidate_type || null;
    },
    age() {
      return this.candidateInfo?.age != null
        ? `${this.candidateInfo?.age} Years`
        : null;
    },
    role() {
      return this.candidateInfo?.role || null;
    },
    gender() {
      return this.candidateInfo?.gender?.gender != null
        ? `${this.candidateInfo?.gender?.gender}, `
        : null;
    },
    nationality() {
      return this.candidateInfo?.nationality?.nationality != null
        ? `${this.candidateInfo?.nationality?.nationality}, `
        : null;
    },
    profile() {
      return {
        ...this.getJobDetailsById,
      };
    },
    isCandidateDetailsNotEmpty() {
      return (
        isObject(this.candidateDetails) &&
        !isEmptyObjectCheck(this.candidateDetails)
      );
    },
    candidateTabs() {
      let tabs = this.getJobCandidateTabs;
      tabs = [
        { tab_id: null, tab_name: "Details" },
        ...tabs,
        { tab_id: null, tab_name: "Comments" },
      ];
      return tabs;
    },
    tab_id() {
      return this.getTabInfo?.tab_id || null;
    },
    candidateStatus() {
      return this.candidateDetails?.status?.display_text || null;
    },
    candidateSubStatus() {
      return this.candidateDetails?.sub_status?.display_text || null;
    },
    index_selectedCandidate() {
      let selectedCandidate_id =
        this.candidateDetails?.candidate?.candidate_uid;
      return this.getCandidateListForJobID.findIndex(
        ({ candidate }) => candidate?.candidate_uid === selectedCandidate_id
      );
    },
    previousCandidate() {
      if (this.candidateDetails && this.index_selectedCandidate) {
        if (
          this.getCandidateListForJobID &&
          this.getCandidateListForJobID.length
        ) {
          if (this.index_selectedCandidate > 0)
            return this.getCandidateListForJobID[
              this.index_selectedCandidate - 1
            ];
        }
      }
      return null;
    },
    nextCandidate() {
      if (this.candidateDetails) {
        let customer_uid = this.candidateDetails?.candidate?.customer_uid;
        let candidate_uid = this.candidateDetails?.candidate?.candidate_uid;
        this.fetchspecialInterest({
          customer_uid: customer_uid,
          candidate_uid: candidate_uid,
        });
        this.fetchCandidateNonMedicalQuals({
          customer_uid: customer_uid,
          candidate_uid: candidate_uid,
        });
      }
      if (this.candidateDetails && this.index_selectedCandidate > -1) {
        if (
          this.getCandidateListForJobID &&
          this.getCandidateListForJobID.length
        ) {
          if (
            this.index_selectedCandidate > -1 &&
            this.index_selectedCandidate <
              this.getCandidateListForJobID.length - 1
          )
            return this.getCandidateListForJobID[
              this.index_selectedCandidate + 1
            ];
        }
      }
      return null;
    },
    candidateActions() {
      return (
        (this.candidateDetails &&
          this.candidateDetails.actions &&
          this.candidateDetails.actions.map((val) => {
            return {
              label: val?.name,
              action_id: val?.id,
              directAction: val?.direct_action,
              status: val?.status,
              filter_id: val?.filter,
              tab_id: val?.tab,
              reason_id: val?.reason,
            };
          })) ||
        []
      );
    },
    candidateProfilePicture() {
      return (
        generateFullUrlWithToken(this.candidateInfo?.profile_picture) ||
        `/img/user_default_pic.png`
      );
    },
    tabs() {
      let tabs = [{ tab_id: null, tab_name: "Details" }];
      if (!this.isCandidateRole && !this.isCustomerUserRole) {
        let dynamicTabs = this.getJobCandidateTabs;
        tabs = [
          ...tabs,
          ...dynamicTabs,
          { tab_id: null, tab_name: "History" },
          //  { tab_id: null, tab_name: "Offer" },
        ];
      }
      return tabs;
    },
    isJobFound() {
      return (
        this.isFetchingJobDetails &&
        isObject(this.getJobDetailsById) &&
        !isEmptyObjectCheck(this.getJobDetailsById)
      );
    },
    jobDocuments() {
      return (
        this.getJobDocuments?.length &&
        this.getJobDocuments.map(
          ({
            document_type_id,
            link_to_doc,
            document_name,
            document_type,
            created_on,
            document_ext,
            candidate_document_id,
            comments,
          }) => {
            return {
              document_type_id: document_type_id,
              link: link_to_doc,
              label: document_type.comments,
              name: document_name,
              updatedDate: moment(created_on).format("DD-MM-YYYY"),
              document_ext: document_ext?.document_ext,
              document_id: candidate_document_id,
              comments: comments,
            };
          }
        )
      );
    },
    candidateDocument() {
      return (
        this.getUploadedDocument &&
        this.getUploadedDocument.length &&
        this.getUploadedDocument
          .filter((docs) => {
            return (
              [23, 24].includes(docs.document_type_id) &&
              [this.offerModel.data?.job_id].includes(docs.job_id)
            );
          })
          .map(
            ({
              document_type_id,
              link_to_doc,
              document_name,
              document_type,
              created_on,
              document_ext,
              candidate_document_id,
            }) => {
              return {
                link: link_to_doc,
                label: document_type.comments,
                name: document_name,
                updatedDate: moment(created_on).format("DD-MM-YYYY"),
                document_ext: document_ext?.document_ext,
                document_id: candidate_document_id,
              };
            }
          )
      );
    },
    fileType() {
      if (this.documentType.length) {
        if (
          this.uploadData.document_type &&
          this.uploadData.document_type.code
        ) {
          let fileext = this.documentType
            .filter(({ code }) => code === this.uploadData.document_type.code)
            .map((d) => d.allowed_extensions)[0];
          fileext = fileext.map((d) => d.toLowerCase());
          return fileext;
        } else {
          let fileext = this.documentType
            .filter(({ code }) => code === 23)
            .map((d) => d.allowed_extensions)[0];
          fileext = fileext.map((d) => d.toLowerCase());
          return fileext;
        }
      }
      return [];
    },
    isJobCreatedByParent() {
      return this.getJobDetailsById?.created_by_parent_org?.org_name || "";
    },
  },
  mounted() {
    this.candidateDetails = null;
    this.initFetchOptions();
    let appendAction = [];
    if (
      this.isCandidateRole &&
      isObject(this.getJobDetailsById) &&
      !isEmptyObjectCheck(this.getJobDetailsById)
    ) {
      appendAction = [
        ...appendAction,
        this.commitJobInfo(this.getJobDetailsById),
      ];
    } else {
      appendAction = [
        ...appendAction,
        this.setSelectedjobById(this.$route.params.id),
      ];
    }
    if (!this.documentExtensions.length)
      appendAction = [...appendAction, this.fetchDocumentExtension()];
    const { query } = this.$route;
    if (!this.isCandidateRole && !this.isCustomerUserRole) {
      appendAction = [...appendAction, this.fetchJobCandidateTabs()];
      if (query?.tab_index) {
        this.information_step = parseInt(query?.tab_index);
      } else this.information_step = 1;
    } else {
      this.information_step = 0;
    }
    if (query?.limit) {
      this.$store.commit("SET_JOB_CANDIDATE_PAGINATION", {
        limit: query?.limit,
      });
    }
    appendAction = [
      ...appendAction,
      this.fetchCustomerDocumentLib({
        category: "job",
        request_type__notin: "upload_request",
      }),
    ];
    Promise.all(appendAction).then(async (res) => {
      await this.initJobDetailsFetch();
      this.$nextTick(() => {
        const ele = this.$refs.GenericTabFilters;
        if (ele) {
          ele.initEvent();
          this.fetchInprocessSubTabCount();
        }
      });
      this.fetchJobDoc();
      if (
        ["customer_admin", "customer_recruiter"].includes(this.currentUserRole)
      ) {
        const { job_id } = this.profile;
        this.getPreScreeningQuestions(job_id);
      }
      this.candidateDetails = null;
      if (!this.getNextJobId) this.fetchMoreJobList();
    });
    this.scrollTop();

    const ele = document.getElementById("c-body-app");
    if (ele) {
      ele.addEventListener("scroll", this.onBodyScroll);
    }
    // this.fetchOrgDocumentType();
    this.organisation_id =
      this.getOrgId ||
      this.getUser?.org_detail?.org_id ||
      getLocalOrgDetail()?.organisation_id;

    this.fetchAllVersionDocumentByOrgId({
      organisation_id: this.organisation_id,
    });
    this.fetchOfferActionDetails();
  },
  beforeDestroy() {
    const ele = document.getElementById("c-body-app");
    if (ele) {
      ele.removeEventListener("scroll", this.onBodyScroll);
    }
  },
  methods: {
    ...mapActions([
      "scrollTop",
      "setSelectedjobById",
      "fetchMoreJobList",
      "fetchJobs",
      "commitCandidateInfo",
      "downloadDocument",
      "initJobDetailsFetch",
      "getCandidateDetails",
      "triggerJobCandidateMatch",
      "fetchCandidateList",
      "commitJobInfo",
      "selectedJobBoard",
      "fetchCandidateListForJobID",
      "fetchspecialInterest",
      "commitCandidateInfo",
      "fetchLicense",
      "fetchCandidateLanguage",
      "fetchUploadedDocument",
      "fetchCandidateListForJobIDNew",
      "initFetchCandidates",
      "initUpdateCandidateStatus",
      "addJobCandidateComment",
      "updateJobCandidateStatus",
      "fetchJobCandidateTabs",
      "setCandidateListBackUrl",
      "initShortListInprogessJobs",
      "fetchCurrency",
      "fetchJobCommonComments",
      "fetchCandidateNonMedicalQuals",
      "fetchspecialInterest",
      "getCandidateDetails",
      "fetchJobDocumentsByJobID",
      "downloadDocument",
      "initFetchOptions",
      "showToast",
      "uploadPhoto",
      "uploadResume",
      "deleteDocument",
      "deleteDocumentByCandidateId",
      "create_offer",
      "getOffersForCandidate",
      "fetchUploadedDocumentbyCandidateId",
      "uploadDocumentbycustomer",
      "uploadPhotobycustomer",
      "fetchAllVersionDocumentByOrgId",
      "fetchOfferActionDetails",
      "fetchCustomerDocumentLib",
      "getJobDocumentAction",
      "fetchCustomerDocumentTypes",
      "fetchDocumentExtension",
      "fetchOffersByCandidate",
      "createDocumentAction",
      "updateJobListBackUrl",
      "getPreScreeningQuestions",
      "fetchJobCandidateFrontSheet",
      "addJobCandidateFrontSheet",
      "fetchInterviewCandidateCount",
    ]),
    checkPositiveAction(action) {
      const { action_id } = action;
      const status_id = this.candidateDetails?.status_id;
      const sub_status_id = this.candidateDetails?.sub_status_id;
      const actionIds =
        getPositiveActionIds({ status_id, sub_status_id }) || [];
      return actionIds.includes(action_id);
    },
    fetchJobDoc() {
      const payload = {
        job_id: this.getJobDetailsById?.job_id,
        action_type: "job",
        candidate_uid__isnull: true,
        organisation_id: this.getJobDetailsById?.organisation_uid,
      };
      this.getJobDocumentAction(payload);
      this.fetchCustomerDocumentTypes({
        category: "pre_offer",
        is_custom_type: true,
      });
    },
    backtocardview() {
      this.$router.push(this.jobListBackUrl).then((res) => {
        this.$store.commit("REMOVE_JOB_LIST_BACK_URL", this.jobListBackUrl);
      });
    },
    navigateto(id) {
      this.fetchJobCommonComments(id);
      this.$router.push({ path: `/job-list-preview/${id}` });
    },
    navigateToCandidateDetail() {
      this.setCandidateListBackUrl(this.$route.fullPath);
      this.$router.push(candidateDetailPath(this.candidateId));
    },
    toTitleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    /* fileDownload(data) {
      let { link, name: document_name } = data;
      let url = link.replace("/api/v1/", "");
      this.downloadDocument({ url, document_name });
      return false;
    },*/
    handleCandidateSelect(candidateDetails) {
      if (candidateDetails) {
        const { candidate, sub_status } = candidateDetails;
        const { candidate_uid } = candidate;
        this.updateQuery({ candidate_uid });
        this.candidateDetails = candidateDetails;
        let appendAction;
        appendAction = this.commitCandidateInfo(candidate);
        Promise.all([appendAction]).then((res) => {
          if (this.step2 === 2) this.initShortListInprogessJobs();
          this.fetchspecialInterest();
          this.fetchLicense();
          this.fetchCandidateLanguage();
          this.fetchUploadedDocument();
          this.fetchCurrency();
        });
      }
      setTimeout(() => {
        document.getElementById("candidateDetails").scrollIntoView();
      }, 100);
    },

    candidateState(event) {
      let name = event.currentTarget.name;
      let cname = {
        delete: "Delete",
        deactivate: "Deactivate",
      };
      this.popupModal.modalReasonType = name.toUpperCase();
      this.popupModal.modalTitle = `NOTIFICATION`;
      this.popupModal.modalContent = `Are you sure to ${name.toLowerCase()} the candidate? If Yes please select an appropriate reason..`;
      this.popupModal.isShowPopup = true;
      if (name === cname.delete || name === cname.deactivate) {
        this.popupModal.modalColor = "danger";
      } else {
        this.popupModal.modalColor = "primary";
      }
    },

    arrowClick(direction) {
      let e = document.querySelector("#otherinfoNav");
      if (e != null)
        if (direction === "left") {
          e.scrollLeft -= 150;
        } else if (direction === "right") {
          e.scrollLeft += 150;
        }
    },
    goToPreferenceSection() {
      this.$refs.GenericTabFilters.selectTab(0, null);
      this.tabSelectCallBack({ index: 0 });
      setTimeout(() => {
        this.$refs.JobRequirementDetails.isExpand.qualification = true;
        let el = this.$el.getElementsByClassName(
          "jobQualification-info-section"
        )[0];
        // el.scrollIntoView(true);
        el.scrollIntoView({ block: "center" });
        window.scrollBy(0, -70);
      }, 50);
    },
    goToSalaryAndBenefitsSection() {
      this.$refs.GenericTabFilters.selectTab(0, null);
      this.tabSelectCallBack({ index: 0 });
      setTimeout(() => {
        this.$refs.JobRequirementDetails.isExpand.salary = true;
        let el = this.$el.getElementsByClassName("jobBenefits-info-section")[0];
        // el.scrollIntoView(true);
        el.scrollIntoView({ block: "center" });
        window.scrollBy(0, -70);
      }, 50);
    },
    postedDate(postdate) {
      return moment(postdate).format("DD-MM-YYYY");
    },
    onBodyScroll(e) {
      if (this.noMoreCandidates) return;
      if (
        e.target.clientHeight + e.target.scrollTop >=
          e.target.scrollHeight - 1 &&
        this.getDisplayStatusSubStatus.length &&
        this.tab_id
      ) {
        this.fetchCandidateListForJobIDNew({ pagination: true }).then((res) => {
          const { skip, limit } = this.getJobCandidatePagination;
          this.updateQuery({ limit: skip + limit });
        });
      }
    },
    fetchCandidateNew(data) {
      let payload = { pagination: data || false };
      this.initFetchCandidates(payload);
    },
    refreshCallBack() {
      let appendAction = this.triggerJobCandidateMatch(
        this.getJobDetailsById?.job_id
      );
      Promise.all([appendAction]).then((res) => {
        this.fetchCandidateListForJobIDNew({ pagination: false });
      });
    },
    filterCallBack(isFavourite) {
      this.fetchCandidateListForJobIDNew({ pagination: false, isFavourite });
    },
    tabSelectCallBack({ index, tab_id }) {
      this.information_step = index;
      this.updateQuery({ tab_index: index }, true);
      if (tab_id === 4) {
        this.fetchInprocessSubTabCount();
      }
    },
    fetchInprocessSubTabCount() {
      const { job_id } = this.getJobDetailsById;
      
      const isTFMuser = this.getPathAcronymFromAccessToken === "tfm";
      const customer_id = isTFMuser ? this.getJobDetailsById?.customer_uid : this.getCustomerId;
      const tab_id = 4;
      this.fetchInterviewCandidateCount({
        job_id,
        tab_id,
        filter_id__in: 28,
        customer_id,
      }).then((res) => {
        if (res.status == 200) {
          const { data } = res;
          this.inProcessSubCount.interview = data;
        }
      });
      this.fetchInterviewCandidateCount({
        job_id,
        tab_id,
        filter_id__in: 30,
        customer_id,
      }).then((res) => {
        if (res.status == 200) {
          const { data } = res;
          this.inProcessSubCount.onboard = data;
        }
      });
      this.fetchInterviewCandidateCount({
        job_id,
        tab_id,
        filter_id__in: 27,
        customer_id,
      }).then((res) => {
        if (res.status == 200) {
          const { data } = res;
          this.inProcessSubCount.submitted = data;
        }
      });
      this.fetchInterviewCandidateCount({
        job_id,
        tab_id,
        filter_id__in: 29,
        customer_id,
      }).then((res) => {
        if (res.status == 200) {
          const { data } = res;
          this.inProcessSubCount.offered = data;
        }
      });
    },
    updateQuery(v, reset = false) {
      let { query, path } = this.$route;
      if (reset) query = {};
      if (!_.isEqual(v, query))
        this.$router.replace({ path, query: { ...query, ...v } });
    },
    fastTrackModalCallBack(action, payload) {
      this.fastTrackModal.isShowPopup = false;
      if (!action) this.fastTrackModal.isShowPopup = false;
      if (action && payload) {
        const { job_id, candidate } = this.fastTrackModal;
        const { candidate_uid } = candidate;
        let uploadPayload = {
          updateStatusSubStatus: {
            update_status: 54,
            update_sub_status: 55,
          },
        };
        uploadPayload = {
          ...uploadPayload,
          payloadData: { job_id, candidate_uid, payload },
        };
        this.updateJobCandidateStatus(uploadPayload).then((res) => {
          this.fetchCandidateListForJobIDNew({ pagination: false });
          this.fastTrackModal.isShowPopup = false;
          this.fastTrackModal.job_id = null;
          this.candidateDetails = null;
        });
      }
    },
    errorModalCallBack(action, payload) {
      this.errorModal.isShowPopup = false;
      if (!action) this.errorModal.isShowPopup = false;
      if (action && payload) {
        const { job } = this.errorModal;
        const { candidate } = this.errorModal;
        const { job_id } = job;
        const { candidate_uid } = candidate;
        const {
          status_id: update_status,
          sub_status_id: update_sub_status,
          comments,
        } = payload;
        let uploadPayload = {
          updateStatusSubStatus: {
            update_status,
            update_sub_status,
          },
        };
        uploadPayload = {
          ...uploadPayload,
          payloadData: { job_id, candidate_uid, payload: comments },
        };
        this.updateJobCandidateStatus(uploadPayload).then((res) => {
          this.fetchCandidateListForJobIDNew({ pagination: false });
          this.errorModal.isShowPopup = false;
          this.candidateDetails = null;
        });
      }
    },
    actionModalCallBack(action, payload) {
      if (!action) this.actionModal.isShowPopup = false;
      if (action && payload) {
        const { job_id } = this.getJobDetailsById;
        const candidate_uid = this.actionModal.candidate_uid;
        const appentAction = this.initUpdateCandidateStatus({
          candidate_uid,
          job_id,
          payload,
        });
        Promise.all([appentAction]).then((res) => {
          if (res) {
            this.actionModal.isShowPopup = false;
            this.actionModal.candidate_uid = null;
            this.candidateDetails = null;
            if (this.tab_id === 4) {
              this.fetchInprocessSubTabCount();
            }
            this.fetchCandidateListForJobIDNew({ pagination: false });
          }
        });
      }
    },
    offerOnBoardModalCallBack(action, data) {
      if (action && data) {
        const { documentPayload, processPayload, actionPayload } = data;
        let appendAction = [];
        documentPayload.forEach((element) => {
          appendAction = [...appendAction, this.createDocumentAction(element)];
        });
        Promise.all(appendAction).then(async (res) => {
          await this.initUpdateCandidateStatus(processPayload);
          this.offerOnBoardModal.isShowPopup = false;
          this.offerOnBoardModal["job_id"] = null;
          this.offerOnBoardModal["details"] = null;
          this.offerOnBoardModal["action"] = null;
          if (this.tab_id === 4) {
            this.fetchInprocessSubTabCount();
          }
        });
      } else {
        this.offerOnBoardModal.isShowPopup = false;
      }
    },
    openCommentModal(messageId, columnKey) {
      this.commentModal.isShowPopup = true;
      this.commentModal.candidate_id = this.candidateDetails?.candidate_uid;
      this.contactModal[columnKey] = false;
      columnKey ? (this.messageId = messageId) : (this.messageId = null);
      columnKey ? (this.isBtnHide = false) : true;
    },
    commentModalCallBack(action, payload) {
      if (action) {
        const { job_id } = this.getJobDetailsById;
        payload = {
          ...payload,
          candidate_id: this.commentModal.candidate_id,
          job_id,
          contact_method: this.methods,
          message_id: this.messageId,
        };
        this.addJobCandidateComment(payload).then((res) => {
          this.commentModal.isShowPopup = false;
          this.commentModal.candidate_id = null;
          if (this.information_step === 5)
            this.$refs.historyInfo.fetchJobAuditHistory(false);
        });
      } else {
        this.commentModal.isShowPopup = false;
      }
    },
    actionModalEvent(payload) {
      const { candidateDetails, selectedAction } = payload;
      const { action_id, directAction, status, reason_id } = selectedAction;
      const { candidate_uid, candidate } = candidateDetails;
      const { job_id } = this.getJobDetailsById;
      const jobDetails = this.getJobDetailsById;
      if (directAction) {
        let uploadPayload = {};
        uploadPayload = {
          ...uploadPayload,
          payloadData: { job_id, candidate_uid, payload: { reason_id } },
        };
        uploadPayload = { ...uploadPayload, updateStatusSubStatus: status };
        this.updateJobCandidateStatus(uploadPayload).then((res) => {
          this.fetchCandidateListForJobIDNew({ pagination: false });
          this.hideDropDown();
          this.candidateDetails = null;
        });
      } else {
        this.actionModal["candidate_uid"] = candidate_uid;
        this.actionModal["candidateDetails"] = candidateDetails;
        this.actionModal["action"] = selectedAction;
        this.actionModal.job = jobDetails;
        this.actionModal.candidate = candidate;
        const actionData = {
          submission: 14,
          interview: 6,
          offer: 7,
          onboard: 8,
          fastTrack: 18,
          error: 4,
          documents: 16,
        };
        //Restricted for Demo Customer
        if (
          this.getCustomerId === 8 &&
          this.getOrgIDFromAccessToken === 7 &&
          [8, 16, 1].includes(action_id)
        ) {
          this.notificationModal.isShowPopup = true;
          return;
        }
        if (action_id === actionData.submission) {
          if (
            this.getJobDetailsById &&
            this.getJobDetailsById?.job_candidate_users &&
            this.getJobDetailsById?.job_candidate_users?.length
          ) {
            let candidate_reviewers = _(
              this.getJobDetailsById?.job_candidate_users
            )
              .filter(({ customer_user }) => {
                return customer_user?.customer_user_type_id == 74; // candidate_reviewer, was 1
              })
              .value();
            if (!candidate_reviewers?.length) {
              const msg =
                "No Reviewer Found ! Please update a Submission Reviewer for the job !!";
              this.$store.commit("SET_UPDATE_TOAST_VISIBLE", {
                isShow: true,
                msg,
                cssClass: "bg-danger text-white",
              });
              return;
            } else if (candidate_reviewers?.length) {
              this.fetchJobCandidateFrontSheet({ job_id, candidate_uid }).then(
                (res) => {
                  this.frontSheetModal.comments = res?.data || [];
                  if (res?.data?.length) {
                    this.submissionModal["isShowPopup"] = true;
                  } else {
                    this.confirmationModal["isShowPopup"] = true;
                    this.frontSheetModal.job = jobDetails;
                    this.frontSheetModal.candidate = candidate;
                    this.frontSheetModal.frontSheetInfo = null;
                  }
                }
              );
            }
          } else {
            const msg =
              "No Reviewer Found ! Please update a Submission Reviewer for the job !!";
            this.$store.commit("SET_UPDATE_TOAST_VISIBLE", {
              isShow: true,
              msg,
              cssClass: "bg-danger text-white",
            });
            return;
          }
        } else if (action_id === actionData.interview) {
          if (
            this.getJobDetailsById &&
            this.getJobDetailsById?.job_candidate_users &&
            this.getJobDetailsById?.job_candidate_users?.length
          ) {
            let candidate_interviewers = _(
              this.getJobDetailsById?.job_candidate_users
            )
              .filter(({ customer_user }) => {
                return customer_user?.customer_user_type_id == 75; // candidate_interviewer, was 2
              })
              .value();
            if (!candidate_interviewers?.length) {
              const msg =
                "No Interviewer Found ! Please update a Candidate Interviewer for the job !!";
              this.$store.commit("SET_UPDATE_TOAST_VISIBLE", {
                isShow: true,
                msg,
                cssClass: "bg-danger text-white",
              });
              return;
            } else if (candidate_interviewers?.length) {
              this.interViewModal["isShowPopup"] = true;
            }
          } else {
            const msg =
              "No Interviewer Found ! Please update a Candidate Interviewer for the job !!";
            this.$store.commit("SET_UPDATE_TOAST_VISIBLE", {
              isShow: true,
              msg,
              cssClass: "bg-danger text-white",
            });
            return;
          }
        } else if (action_id === actionData.offer) {
          const checkListPayload = {
            job: jobDetails,
            organisation_id: jobDetails.organisation_uid,
            ...candidateDetails,
          };
          this.openCheckList(checkListPayload, 1, "offer");
        } else if (action_id === actionData.onboard) {
          const checkListPayload = {
            job: jobDetails,
            organisation_id: jobDetails.organisation_uid,
            ...candidateDetails,
          };
          this.openCheckList(checkListPayload, 1, "licensing");
        } else if (action_id === actionData.fastTrack) {
          this.fastTrackModal["job_id"] = job_id;
          this.fastTrackModal["details"] = {
            jobDetails,
            ...candidateDetails,
          };
          this.fastTrackModal["action"] = selectedAction;
          this.fastTrackModal.isShowPopup = true;
          this.fastTrackModal["candidate"] = candidate;
          this.fastTrackModal["job"] = jobDetails;
        } else if (action_id === actionData.error) {
          this.errorModal.job = jobDetails;
          this.errorModal.candidate = candidate;
          this.errorModal.action = selectedAction;
          this.errorModal["isShowPopup"] = true;
        } else if (action_id === actionData.documents) {
          const checkListPayload = {
            jobDetails,
            organisation_id: jobDetails.organisation_uid,
            ...candidateDetails,
          };
          this.openCheckList(checkListPayload, 1, "offer");
        } else {
          this.actionModal["isShowPopup"] = true;
        }
      }
    },
    candidateActionEvent(action) {
      const candidateDetails = this.candidateDetails;
      let payload = { candidateDetails, selectedAction: action };
      this.actionModalEvent(payload);
    },
    hideDropDown() {
      const cols = document.getElementsByClassName("dropdown-menu");
      cols.forEach((element) => {
        element.classList.remove("show");
      });
    },
    openContactModal(columnKey) {
      this.methods = columnKey;
      this.contactModal[columnKey] = true;
    },
    modalCallBack(columnKey) {
      this.contactModal[columnKey] = false;
    },
    fetchShortListInProgressJobs(index) {
      this.step2 = index;
      if (this.step2 === 2) {
        this.initShortListInprogessJobs();
      }
    },
    submissionModalCallBack(action) {
      this.submissionModal["isShowPopup"] = false;
      if (action === "Yes") {
        this.actionModal["isShowPopup"] = true;
      } else {
        this.actionModal["isShowPopup"] = false;
      }
    },
    conversationModalCallBack(deleteId, subject) {
      this.deleteModal.isShowPopup = true;
      this.deleteModal.delete_id = deleteId;
      this.deleteModal.subject = subject;
    },
    deleteModalCallBack() {
      this.deleteModal.isShowPopup = false;
      this.contactModal.email = true;
    },
    interViewModalCallBack(action) {
      this.interViewModal["isShowPopup"] = false;
      if (action === "Yes") {
        this.actionModal["isShowPopup"] = true;
      } else {
        this.actionModal["isShowPopup"] = false;
      }
    },
    onCancelClicked() {
      this.payload = {};
      this.offerModel.isShowPopup = false;
    },
    onSubmitClicked() {
      if (this.getUploadedDocument.length != 0) {
        this.payload = {
          status: false,
          candidate_uid: this.offerModel.data.candidate.candidate_uid,
          customer_uid: this.offerModel.data.candidate.customer_uid,
          job_id: this.offerModel.data?.job_id,
        };
        //console.log(this.payload);
        //console.log(this.offerModel.data.candidate.candidate_uid,this.offerModel.data.candidate.customer_uid,this.offerModel.data?.job_id)
        this.create_offer(this.payload);
        this.showbtn = false;
        this.showToast({
          class: "bg-success text-white",
          message: "Offer sent to Candidate!",
        });
      } else {
        this.showToast({
          class: "bg-danger text-white",
          message: "Select the files.",
        });
      }
    },
    formatDate(date) {
      if (date) return moment(date).format("DD MMM YYYY");
      return "--";
    },
    onTabChange(tabIndex) {
      // if (tabIndex == 0) {
      //   let job_id  = this.offerModel.data?.job_id
      //   console.log(job_id);
      //   this.fetchJobDocumentsByJobID(job_id)
      // }
    },
    fetchOfferCandidates() {
      // this.$store.commit("SET_CANDIDATE_LIST_FOR_JOB_ID", []);
      let appendAction = [];
      let payload = {
        pagination: false,
        displayStatusSubStatus: [
          { display_status: 58, display_sub_status: 59 },
        ],
      };
      // appendAction = [this.fetchCandidateListForJobIDNew(payload)];
      this.fetchCandidateListForJobIDNew(payload).then((res) => {
        const ele = document.getElementById("c-body-app");
        if (ele) {
          ele.addEventListener("scroll", this.onBodyScroll);
        }
      });
      // Promise.all(appendAction).then(res => {
      //   console.log('Response');
      // });
    },
    previewCV(candidate) {
      const { link_to_cv_doc, cv_ext: document_ext } = candidate;
      // let link_to_doc = `https://${window.location.host}${link_to_cv_doc}`;
      let link_to_doc = generateFullUrlWithToken(link_to_cv_doc);
      this.preview({ link_to_doc, document_ext });
    },
    preview(data) {
      const { link_to_doc: link_to_document, document_ext } = data;
      this.iframe.url = link_to_document;
      if (["PNG", "JPG", "JPEG", "GIF"].includes(document_ext)) {
        this.iframe.loaded = false;
        this.iframe.ispdf = false;
        this.iframe.isImg = true;
        this.iframe.src = data.link_to_document;
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      } else if (document_ext === "PDF") {
        this.iframe.isImg = false;
        this.iframe.loaded = false;
        this.iframe.pdf.ispdf = true;
        this.iframe.pdf.src = pdf.createLoadingTask(link_to_document);
        setTimeout(() => {
          this.iframe.pdf.src.promise.then((pdf) => {
            this.iframe.pdf.numPages = pdf.numPages;
          });
        }, 100);
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      } else if (["TXT", "EPS", "TIF", "TIFF", "RAW"].includes(document_ext)) {
        this.showToast({
          class: "bg-danger text-white",
          message: "The selected file type is not available for Preview.",
        });
        this.iframe.src = "";
        this.iframe.loaded = false;
        this.iframe.isImg = false;
        this.iframe.pdf.ispdf = false;
        this.previewModal.isPreview = false;
        this.previewModal.isShowPopup = false;
      } else {
        this.iframe.isImg = false;
        this.iframe.ispdf = false;
        this.iframe.loaded = true;
        this.iframe.src =`https://view.officeapps.live.com/op/embed.aspx?src=${link_to_document}`;
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      }
    },
    previewModalCallBack(action) {
      this.previewModal.isPreview = false;
      this.previewModal.isShowPopup = false;
      this.iframe.src = "";
      this.iframe.loaded = false;
      this.iframe.isImg = false;
      this.iframe.pdf.ispdf = false;
    },
    checkFastTrack(actions) {
      return (actions && actions.some((v) => v?.action_id === 18)) || false;
    },
    openFastTrackModal() {
      const fastTrackData = {
        label: "Fast Track",
        action_id: 18,
        directAction: null,
        status: null,
        filter_id: 5,
        tab_id: 3,
        reason_id: null,
      };
      this.candidateActionEvent(fastTrackData);
    },
    frontSheetModalCallBack(action, payload) {
      if (action && payload) {
        this.addJobCandidateFrontSheet(payload).then((res) => {
          this.frontSheetModal.isShowPopup = false;
          this.actionModal.isShowPopup = true;
        });
      } else {
        this.frontSheetModal.isShowPopup = false;
      }
    },
    confirmationModalCallBack(action) {
      if (action?.button === "Create") {
        this.frontSheetModal.isShowPopup = true;
      }
      this.confirmationModal.isShowPopup = false;
    },
    openFrontSheet(candidate = {}, job = {}) {
      const { candidate_uid } = candidate;
      const { job_id } = job;
      this.fetchJobCandidateFrontSheet({
        job_id,
        candidate_uid,
        order_by: "-job_candidate_front_sheet_id",
      }).then((res) => {
        if (res?.status === 200) {
          this.frontSheetModal.job = job;
          this.frontSheetModal.candidate = candidate;
          this.frontSheetModal.comments = res.data;
          this.frontSheetModal.frontSheetInfo = res.data[0];
          this.frontSheetModal.isShowPopup = true;
          this.actionModal.isShowPopup = false;
        }
      });
    },
    notificationModalCallBack(action) {
      this.notificationModal.isShowPopup = false;
    },
    openCheckList(data = {}, activeTab = 0, accordion = null) {
      const { candidate, job } = data;
      this.checkListModal.isShowPopup = true;
      this.checkListModal.actionInfo = data;
      this.checkListModal.candidateDetails = candidate;
      this.checkListModal.jobDetails = job;
      this.checkListModal.activeTab = activeTab;
      this.checkListModal.accordion = accordion;
    },
    checkListModalCallBack(action, data) {
      this.checkListModal.isShowPopup = false;
      this.fetchCandidateListForJobIDNew({ pagination: false });
      if (this.tab_id === 4) {
        this.fetchInprocessSubTabCount();
      }
    },
    uploadDocActionCallBack(data) {
      if (data) {
        const { documentPayload, processPayload, actionPayload } = data;
        let appendAction = [];
        documentPayload.forEach((element) => {
          appendAction = [...appendAction, this.createDocumentAction(element)];
        });
        Promise.all(appendAction).then(async (res) => {
          await this.initUpdateCandidateStatus(processPayload);
          this.checkListModal.isActionCompleted = true;
        });
      }
      return;
    },
  },
  watch: {
    nextCandidate(val) {
      if (
        !this.noMoreCandidates &&
        val === null &&
        this.information_step != 6
      ) {
        this.fetchCandidateListForJobIDNew({ pagination: true });
      }
      return;
    },
    "$route.params.id": function (id) {
      let appendAction = this.setSelectedjobById(this.$route.params.id);
      this.candidateDetails = null;
      Promise.all([appendAction]).then(async (res) => {
        await this.initJobDetailsFetch();
        this.fetchJobDoc();
        if (
          ["customer_admin", "customer_recruiter"].includes(
            this.currentUserRole
          )
        ) {
          const { job_id } = this.profile;
          this.getPreScreeningQuestions(job_id);
        }
        if (!this.getNextJobId) await this.fetchMoreJobList();
        await this.fetchCandidateListForJobIDNew({ pagination: false });
        const oldBackURL = this.jobListBackUrl;
        const urlObj = urlParse.parse(oldBackURL, true);
        if (urlObj && urlObj.pathname.includes("job-list")) {
          let { pathname, query } = urlObj;
          query.page = this.getJobPaginationPageNumber;
          const newBackURL = `${pathname}?${getFilterQueryStringWithoutArray(
            query
          )}`;
          this.updateJobListBackUrl({ oldBackURL, newBackURL });
        }
      });
    },
    voiceCallModal(value) {
      this.contactModal.phone = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.sub-menu {
  width: 12rem;
  padding: 1rem 0.5rem;
}
.job-label {
  // margin-left: 1.5rem;
  margin-top: 0.25rem;
  span.bold {
    font-weight: 600;
  }
  .reference {
    label.setfont {
      font-weight: normal !important;
    }
  }
}

.job-label .expiry {
  margin-left: 0.5rem !important;
}
label {
  font-weight: bold;
  opacity: 0.9;
  font-size: 0.8rem;
}
span {
  font-size: 0.8rem;
}
i {
  font-size: 0.9rem;
}
.candidateimg {
  height: 7rem;
  width: 7rem;
}
.w-33 {
  width: 33% !important;
}
.paddingself {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.btnpadding {
  padding-left: 0.4rem !important;
  padding-right: 0.4rem !important;
}
.text-gold {
  color: #ff7600;
}
.w-85 {
  width: 85px;
}
.w-70 {
  width: 70px;
}
.w-67 {
  width: 67%;
}
.bottom-line {
  margin-bottom: 6px;
  border-bottom: dotted #eee 2px;
  padding-top: 8px;
}
.candidate-arrow {
  cursor: pointer;
  i {
    font-size: 20px;
  }
}
.action-1,
.action-2 {
  width: 75px;
  height: 24px;
  font-size: 11px;
  margin: auto;
}
.action-set {
  margin-right: 0;
  margin-left: auto;
  @media all and (max-width: 480px) {
    float: none;
    margin: auto;
  }
}
.drop-padding {
  padding: 0.25rem 0;
  cursor: pointer;
  width: 75px;
}
.circle-border {
  border: 1px solid #dd3651;
  border-radius: 50%;
  padding: 0.25rem 0.5rem;
}
.text-primary-disabled {
  color: #a9a9a9;
}
.circle-border-disabled {
  border: 1px solid #a9a9a9 !important;
  border-radius: 50%;
  padding: 0.25rem 0.5rem;
  cursor: default;
}
.cursor-default {
  cursor: default;
}
.ratio-1 {
  aspect-ratio: 1;
}
.hand-icon {
  cursor: pointer;
}

.action-button {
  width: 14px;
  height: 14px;
  border: 0;
  background: transparent;
  padding: 0;
  outline: none;
}
.positive-action {
  background-color: lightgreen;
}
</style>
